import { context } from "../../wr-context";
import { makeAction, WorkflowUnit } from "./../workflow";
import { isPathMatch } from "./utils";
var PRODUCT_SELECTION_KEY = "documentGeneration";
export var redirectToDocumentGeneration = makeAction("redirectToDocumentGeneration", function() {
    // TODO: Standardize these so that only one remains
    var targetRoute = context.getRoutePath("document-edit") || context.getRoutePath("documentEdit");
    context.history.push(targetRoute);
}, function() {
    return isPathMatch("document-edit");
});
export var defaultActions = [
    redirectToDocumentGeneration
];
export var createDocumentGenerationUnit = function(options) {
    var ref;
    var productSelectionActions = (ref = options === null || options === void 0 ? void 0 : options.actions) !== null && ref !== void 0 ? ref : defaultActions;
    return new WorkflowUnit(PRODUCT_SELECTION_KEY, productSelectionActions);
};
var DocumentGenerationUnit = createDocumentGenerationUnit();
export default DocumentGenerationUnit;
